import type { AnalyticsService } from './types';

declare global {
  interface Window {
    plausible?: (
      event: string,
      options?: { props?: Record<string, string | string[]>; u?: string },
    ) => void;
  }
}

export const PlausibleAnalyticsService: AnalyticsService = {
  initialize: async () => {
    // Script is loaded via next/script in layout.tsx
  },

  trackPageView: async () => {
    // Plausible auto-tracks page views (including SPA navigations).
    // Manual calls would cause double-counting and lose UTM attribution.
  },

  trackEvent: async (
    eventName: string,
    eventProperties?: Record<string, string | string[]>,
  ) => {
    try {
      if (
        typeof window !== 'undefined' &&
        typeof window.plausible === 'function'
      ) {
        window.plausible(eventName, { props: eventProperties });
      }
    } catch {
      // Plausible may not be fully initialized – silently ignore
    }
  },

  identify: async () => {
    // Plausible is privacy-first – no user identification
  },
};
